<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { Modal } from '@shared/ui/modal';
  import { Portal } from '@shared/ui/portal';

  import { ReportForm } from '@features/report';
  import type { reportConfig } from '@features/report';

  import SuccessState from './success.svelte';

  export let form: reportConfig.ReportForm;
  export let formAction: string | undefined = undefined;

  let isSubmitted = false;
  let isOpen = false;

  const handleSubmit = () => {
    isSubmitted = !isSubmitted;
  };

  const handleToggle = () => {
    isOpen = !isOpen;
    isSubmitted = false;
  };
</script>

<button on:click="{handleToggle}" class="group flex items-center gap-3">
  <Icon name="report" />

  <div
    class="underline-group-hover underline-static underline-top-1 before:bg-default-900/50 after:bg-default-600/50 dark:before:bg-default-200/50"
  >
    Report
  </div>
</button>

<Portal>
  <Modal
    bind:open="{isOpen}"
    outsideClose
    dismissible
    size="xl"
    title="{!isSubmitted ? 'Report a problem' : ''}"
    hasFooter="{false}"
    headerClasses="px-5 pt-5 pb-5 md:px-6 md:pt-6 md:pb-5"
    bodyClasses="px-5 md:px-6"
    footerClasses="mb-5 md:mb-6"
  >
    {#if !isSubmitted}
      <p class="mb-5 text-base">
        If you encounter a problem, misinformation, violation of rights, possible errors, or difficulties, please feel
        free to contact us.
      </p>

      <ReportForm formData="{form}" {formAction} on:successSubmit="{handleSubmit}" {isOpen} />
    {:else}
      <div class="mt-4 p-4 md:p-12">
        <SuccessState on:click="{handleToggle}" />
      </div>
    {/if}
  </Modal>
</Portal>
